import { Language, PhotoRequestTabTypes } from '^/types';

const { ALL, COMPLETED, DRAFT, REQUESTED }: typeof PhotoRequestTabTypes = PhotoRequestTabTypes;
export default {
  photoRequest: {
    [Language.EN_US]: 'Photo Request',
    [Language.KO_KR]: '사진 요청',
  },
  emptyState: {
    [ALL]: {
      title: {
        [Language.EN_US]: 'No missions yet',
        [Language.KO_KR]: '비행 계획이 없습니다',
      },
      infoText: {
        [Language.EN_US]: 'Press the ‘New Mission’ below',
        [Language.KO_KR]: '아래의 ‘새 비행 계획하기’ 버튼 누르세요.',
      },
    },
    [COMPLETED]: {
      title: {
        [Language.EN_US]: 'No completed missions',
        [Language.KO_KR]: '완료된 미션이 없습니다',
      },
      infoText: {
        [Language.EN_US]: 'Your completed missions will show up here.',
        [Language.KO_KR]: '완료된 미션이 여기에 표시됩니다',
      },
    },
    [DRAFT]: {
      title: {
        [Language.EN_US]: 'No drafts',
        [Language.KO_KR]: '임시 저장된 미션이 없습니다',
      },
      infoText: {
        [Language.EN_US]: 'All drafts have been either submitted or deleted.',
        [Language.KO_KR]: '모든 임시 저장 미션이 제출되거나 삭제되었습니다',
      },
    },
    [REQUESTED]: {
      title: {
        [Language.EN_US]: 'No ongoing missions',
        [Language.KO_KR]: '진행 중인 미션이 없습니다',
      },
      infoText: {
        [Language.EN_US]: 'All your missions have been completed.',
        [Language.KO_KR]: '모든 미션이 완료되었습니다',
      },
    },
  },
  newMission: {
    [Language.EN_US]: 'New Mission',
    [Language.KO_KR]: '새 비행 계획하기',
  },
  reachedLast: {
    [Language.EN_US]: 'You’ve reached the last mission.',
    [Language.KO_KR]: '마지막 미션입니다.',
  },
};
